<template>
    <div class="Profile">
        <div class="container">
            <h2>{{'My Account' | language}}</h2>
            <p>{{'Welcome back' | language}}, {{ user.username }}</p>

            <div class="row">
                <div class="col-sm-6 col-xs-12">
                    <el-form :model="profile" status-icon ref="form" label-width="120px" class="demo-ruleForm" :rules="rules_profile"
                    @submit.native.prevent
                    :label-position="labelPosition">

                        <h5>{{'Update account details' | language}}</h5>

                        <el-alert title="Account update error" type="error" v-if="profileError"
                            :description="profileError.message" show-icon>
                        </el-alert>
                        <el-alert title="Account details have been updated successfully" type="success" v-if="profileSuccess"
                            :description="profileSuccess.message" show-icon>
                        </el-alert>

                        <el-form-item :label="'Name' | language" prop="username">
                            <el-input v-model="profile.username" autocomplete="off" @keyup.enter.native="changeProfile('form')"></el-input>
                        </el-form-item>
                        <el-form-item :label="'Email' | language" prop="email">
                            <el-input v-model="profile.email" autocomplete="off" @keyup.enter.native="changeProfile('form')"></el-input>
                        </el-form-item>
                        <el-form-item :label="'Company' | language" prop="company">
                            <el-input v-model="profile.company" autocomplete="off" @keyup.enter.native="changeProfile('form')"></el-input>
                        </el-form-item>
                        <el-form-item :label="'Phone' | language" prop="phone">
                            <el-input v-model="profile.phone" autocomplete="off" @keyup.enter.native="changeProfile('form')"></el-input>
                        </el-form-item>
                        <el-form-item>
                            <el-button class="__Button" type="primary" @click="changeProfile('form')" :loading="profileLoading">{{'Update Info' | language}}</el-button>
                        </el-form-item>
                    </el-form>
                </div>

                <div class="col-sm-6 col-xs-12">
                    <el-form :model="form" status-icon ref="pasForm" label-width="120px" class="demo-ruleForm" :rules="rules"
                    @submit.native.prevent
                    :label-position="labelPosition"
                    id="passwordForm">

                        <h5>{{'Change Password' | language}}</h5>

                        <el-alert title="You current password is incorrect" type="error" v-if="pwError"
                            :description="pwError.message" show-icon>
                        </el-alert>
                        <el-alert title="Password has been updated successfully" type="success" v-if="pwSuccess"
                            :description="pwSuccess.message" show-icon>
                        </el-alert>

                        <el-form-item :label="'Current password' | language" prop="current_password">
                            <el-input type="password" v-model="form.current_password" autocomplete="off" @keyup.enter.native="changePassword('pasForm')"></el-input>
                        </el-form-item>
                        <el-form-item :label="'New password' | language" prop="password">
                            <el-input type="password" v-model="form.password" autocomplete="off" @keyup.enter.native="changePassword('pasForm')"></el-input>
                        </el-form-item>
                        <el-form-item :label="'Confirm new password' | language" prop="password_confirmation">
                            <el-input type="password" v-model="form.password_confirmation" autocomplete="off" @keyup.enter.native="changePassword('pasForm')"></el-input>
                        </el-form-item>
                        <el-form-item>
                            <el-button class="__Button" type="primary" @click="changePassword('pasForm')" :loading="pwLoading">{{'Change Password' | language}}</el-button>
                        </el-form-item>
                    </el-form>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { mapState } from 'vuex'

    export default {
        components: {
        },
        props: {
        },
        created(){
            const promise = this.$store.dispatch('user/getMe',{});
            promise
            .then(resp => {
                this.profile = resp.data
            })
        },
        computed: {
            ...mapState({
                user: (state) => {
                    return state.user.user
                }
            })
        },
        data() {
            var validatePassword = (rule, value, callback) => {
                if (value === '') {
                    callback(new Error('Please input the password'));
                } else {
                    if (this.form.password_confirmation !== '') {
                        this.$refs.form.validateField('password_confirmation');
                    }
                    callback();
                }
            };
            var validatePassword2 = (rule, value, callback) => {
                if (value === '') {
                    callback(new Error('Please input the password again'));
                } else if (value !== this.form.password) {
                    callback(new Error('Two inputs don\'t match!'));
                } else {
                    callback();
                }
            };

            return {
                labelPosition: 'top',
                profileSuccess: '',
                pwSuccess:'',
                profileError: '',
                pwError:'',
                profileLoading: false,
                pwLoading: false,
                form: {
                    current_password: '',
                    password: '',
                    password_confirmation: '',
                },
                profile: {},
                rules: {
                    current_password: [
                        { trigger: 'change', required: true },
                    ],
                    password: [
                        { validator: validatePassword, trigger: 'change', required: true },
                        { min: 8, message:'Length should be at least 8' }
                    ],
                    password_confirmation: [
                        { validator: validatePassword2, trigger: 'change', required: true },
                        { min: 8, message: 'Length should be at least 8' }
                    ],
                },
                rules_profile: {
                    username: [
                        { required: true, message: 'Please input username', trigger: 'blur' },
                    ],
                    email: [
                        { required: true, message: 'Please input email address', trigger: 'blur' },
                        { type: 'email', message: 'Please input correct email address', trigger: ['blur', 'change'] }
                    ]
                }
            }
        },
        methods:{
            changeProfile(formName){
                event.preventDefault()
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        this.profileSuccess = ''
                        this.profileError = ''
                        this.profileLoading = true
                        const params = {
                            name : this.profile.username,
                            email : this.profile.email,
                            company : this.profile.company,
                            phone : this.profile.phone
                        }
                        const promise = this.$store.dispatch('user/updateProfile',params)
                        promise
                        .then(resp => {
                            this.profileSuccess = resp.data
                        })
                        .catch(err => {
                            this.profileError = err.response.data
                        })
                        .finally(() => {
                            this.profileLoading = false
                        })
                    } else {
                        return false;
                    }
                });

            },
            changePassword(formName){
                event.preventDefault()
                this
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        this.pwSuccess = ''
                        this.pwError = ''
                        this.pwLoading = true
                        const promise = this.$store.dispatch('user/changePassword',this.form)
                        promise
                        .then(resp => {
                            this.pwSuccess = resp.data
                            this.$refs[formName].resetFields();
                        })
                        .catch(err => {
                            this.pwError = err.response.data
                        })
                        .finally(() => {
                            this.pwLoading = false
                        })

                    } else {
                        return false;
                    }
                });
            }
        },
        head: {
            title: function() {
                return {
                    inner: 'Profile'
                }
            },
            meta: [
                { name: 'title', content: 'My Account on Japan Home Finder' },
                { name: 'keywords', content: 'japan home finder, japan realestate, apartment, house, for rent, for lease' },
                { name: 'description', content: 'Making your Japan home search easier' }
            ]
        }
    }
</script>

<style lang="scss" scoped>
    .Profile {
        padding: 1em 0;

        h2, p {
            text-align: center;
        }

        form {
            max-width: 350px;
            margin: 0 auto;

            .el-form-item {
                &.is-error {
                    margin-bottom: 1.5em!important;
                }
            }
        }

        .__Button {
            width: 100%;
            margin-top: 2em;
        }

        @media (max-width: 767px) {
            padding: 0 0 3em 0;

            #passwordForm {
                margin-top: 2em;
            }
        }
    }
</style>